module.exports = __webpack_public_path__ + "img/bg-1.466a8ea7.png";